import PropTypes from 'prop-types'

import useControlledState from '@s-ui/react-hooks/lib/useControlledState/index.js'
import Injector from '@s-ui/react-primitive-injector'
import {useDelayToNextFrame} from '@adv-mt/mt-hook-use-delay-to-next-frame'

import FilterBasicLabel from './components/Label/index.js'
import {
  ALL_SELECTIONS_ID,
  BASE_CLASS_NAME,
  COMPONENTS,
  DEFAULT_EMPTY_SELECTIONS,
  FORCE_FLAG,
  NO_OP,
  TYPES
} from './config.js'

const FilterBasic = ({
  allSelectionsId = ALL_SELECTIONS_ID,
  allSelectionsImageSrc,
  allSelectionsLabel,
  chips,
  description,
  htmlFor,
  isFullWidth,
  label,
  nodeLabel,
  onChange = NO_OP,
  onBlur,
  onFocus,
  options = [],
  showLabel = false,
  suffix,
  suffixIcon,
  type = TYPES.SINGLE_SELECTION,
  value,
  withDivider,
  withLabel = true
}) => {
  const [innerValue, setInnerValue] = useControlledState(value, DEFAULT_EMPTY_SELECTIONS)

  const delayToNextFrame = useDelayToNextFrame()

  const Component = COMPONENTS[type]

  const handleChange = selections => {
    setInnerValue(selections, FORCE_FLAG)
    delayToNextFrame(() => {
      onChange(selections)
    })
  }

  return (
    <div className={BASE_CLASS_NAME}>
      {withLabel && (
        <FilterBasicLabel
          description={description}
          htmlFor={htmlFor}
          label={label}
          nodeLabel={nodeLabel}
          showLabel={showLabel}
        />
      )}
      <Injector
        allSelectionsId={allSelectionsId}
        allSelectionsImageSrc={allSelectionsImageSrc}
        allSelectionsLabel={allSelectionsLabel}
        chips={chips}
        isFullWidth={isFullWidth}
        onBlur={onBlur}
        onChange={handleChange}
        onFocus={onFocus}
        options={options}
        suffix={suffix}
        suffixIcon={suffixIcon}
        value={innerValue}
        withDivider={withDivider}
      >
        {Component}
      </Injector>
    </div>
  )
}

FilterBasic.displayName = 'FilterBasic'
FilterBasic.propTypes = {
  allSelectionsId: PropTypes.string,
  allSelectionsImageSrc: PropTypes.string,
  allSelectionsLabel: PropTypes.string,
  chips: PropTypes.arrayOf(PropTypes.number),
  description: PropTypes.string,
  htmlFor: PropTypes.string,
  isFullWidth: PropTypes.bool,
  label: PropTypes.string,
  nodeLabel: PropTypes.node,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      extendedInfo: PropTypes.string,
      icon: PropTypes.node,
      id: PropTypes.string,
      isHighlighted: PropTypes.bool,
      label: PropTypes.string,
      nestedItems: PropTypes.arrayOf(
        PropTypes.shape({
          extendedInfo: PropTypes.string,
          icon: PropTypes.node,
          id: PropTypes.string,
          isHighlighted: PropTypes.bool,
          label: PropTypes.string
        })
      )
    })
  ),
  showLabel: PropTypes.bool,
  suffix: PropTypes.string,
  suffixIcon: PropTypes.node,
  type: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.string),
  withDivider: PropTypes.bool,
  withLabel: PropTypes.bool
}

export {ALL_SELECTIONS_ID as filterBasicAllSelectionsId, TYPES as filterBasicTypes}

export default FilterBasic
